$(document).ready(function() {
    $('.full-screen-slider-product-cart').slick({
        centerMode: false,
        arrows: true,
        slidesToShow: 3,
        responsive: [{
                breakpoint: 990,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 630,
                settings: {
                    arrows: false,
                    centerMode: false,
                    dots: false,
                    slidesToShow: 2
                }
            }
        ]
    });
    $(".prev-btn").click(function() {
        $(".full-screen-slider-product-cart").slick("slickPrev");
    });

    $(".next-btn").click(function() {
        $(".full-screen-slider-product-cart").slick("slickNext");
    });
    $(".prev-btn").addClass("slick-disabled");
    $(".full-screen-slider-product-cart").on("afterChange", function() {
        if ($(".slick-prev").hasClass("slick-disabled")) {
            $(".prev-btn").addClass("slick-disabled");
        } else {
            $(".prev-btn").removeClass("slick-disabled");
        }
        if ($(".slick-next").hasClass("slick-disabled")) {
            $(".next-btn").addClass("slick-disabled");
        } else {
            $(".next-btn").removeClass("slick-disabled");
        }
    });
});